import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const QualityRatingReport = () => {
     useAuthRedirect();
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const branch = localStorage.getItem("branch");
    const [sCode, setScode] = useState(null);
    const [sName, setSName] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");


    // Fetch data from API
    useEffect(() => {
        const fetchSupplierItems = async () => {
            setLoading(true);
            try {
                const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vendorRating_quality", {
                    params: { branch },
                });

                if (response.data.purchaseOrderList.length > 0) {
                    setSelectedItems(response.data.purchaseOrderList);
                    setFilteredData(response.data.purchaseOrderList); 
                } else {
                    setSelectedItems([]);
                    setFilteredData([]);
                }
            } catch (error) {
                console.error("Error fetching supplier items:", error);
            }
            finally {
      setLoading(false);
    }
        };

        fetchSupplierItems();
    }, [ branch]);

    // Search Functionality
    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);

        if (!term) {
            setFilteredData(selectedItems); // Reset if search is cleared
            return;
        }

        const filtered = selectedItems.filter((item) =>
            item.SupplierCode?.toString().toLowerCase().includes(term) ||
            item.SupplierName?.toString().toLowerCase().includes(term)
        );

        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page on search
    };

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
  <div className="back-div">
<h2 className="add-txt">Quality Rating - Goods Receipt Note</h2>
<Link to='/inventory/vendorControlRatingMenu'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
</div>
                    
                    <Time />
                </section>

                        {/* Search Box */}
                        <div className="search-filter">
                            <p>Search: </p>
                            <input
                                type="text"
                                placeholder="Search by Supplier Name or Code"
                                value={searchTerm}
                                onChange={handleSearch}
                                className="search-input"
                            />
                        </div>

                        {/* Data Table */}
                        <div className="content-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Supplier Code</th>
                                        <th>Supplier Name</th>
                                        <th>Rating %</th>
                                    </tr>
                                </thead>
                              <tbody>
  {loading ? (
    <tr>
      <td colSpan="4" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => {
      let rating = item.TotalRejectedQty > 0
        ? (item.TotalAcceptedQty / item.TotalPackedQty) * 100
        : 100;

      rating = Math.min(rating, 100); // Ensure max rating is 100%

      return (
        <tr key={index}>
          <td>{indexOfFirstItem + index + 1}</td>
          <td>{item.SupplierCode}</td>
          <td>{item.SupplierName}</td>
          <td>{rating.toFixed(2)}%</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4">No Items</td>
    </tr>
  )}
</tbody>

                            </table>
                        

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="pagination">
                            <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
                                Previous
                            </button>

                            {/* First Page Always Visible */}
                            <button onClick={() => setCurrentPage(1)} className={currentPage === 1 ? 'active' : ''}>
                                1
                            </button>

                            {/* Dynamic Pagination Logic */}
                            {[...Array(Math.min(3, totalPages - 1))].map((_, index) => {
                                const pageNumber = currentPage + index;
                                if (pageNumber > 1 && pageNumber <= totalPages) {
                                    return (
                                        <button key={pageNumber} onClick={() => setCurrentPage(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                                            {pageNumber}
                                        </button>
                                    );
                                }
                                return null;
                            })}

                            {/* Next Button */}
                            <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default QualityRatingReport;
